import React from "react";
import { useEffect } from "react";
import { IBlock } from "../BlockList/Block";
import classes from "./classes.module.scss";
import Dropdown from "../../Dropdown";
import { IOption } from "../../Dropdown/DropdownMenu/DropdownOption";
type IProps = {
	blocks: IBlock[];
	onSelectedBlock: (block: IBlock) => void;
	defaultSelectedBlock?: IBlock;
};

export default function DropdownNavigation({ blocks, onSelectedBlock, defaultSelectedBlock = blocks[0] }: IProps): React.JSX.Element {
	const [selectedBlock, setSelectedBlock] = React.useState<IBlock | null>(defaultSelectedBlock ?? null);

	useEffect(() => {
		if (defaultSelectedBlock) {
			setSelectedBlock(defaultSelectedBlock);
		} else if (blocks.length > 0 && blocks[0]) {
			// If no default selected block, use the first one
			setSelectedBlock(blocks[0]);
		}
	}, [defaultSelectedBlock, blocks]);

	const handleDropDownSelect = (option: IOption): void => {
		const block = blocks.find((block) => block.id === option.id);
		if (block) {
			setSelectedBlock(block);
			onSelectedBlock(block);
		}
	};

	return (
		<div className={classes["root"]}>
			<Dropdown
				options={blocks.map((block) => {
					return {
						id: block.id,
						label: {
							subtext: block.primaryText,
							text: block.secondaryText,
						},
					} as IOption;
				})}
				onSelectionChange={handleDropDownSelect}
				selectedOption={
					selectedBlock
						? { id: selectedBlock.id, label: { text: selectedBlock.secondaryText ?? "", subtext: selectedBlock.primaryText } }
						: undefined
				}
			/>
		</div>
	);
}
